import { render, staticRenderFns } from "./AgConfirmDialog.vue?vue&type=template&id=0768aa1b&scoped=true"
import script from "./AgConfirmDialog.vue?vue&type=script&lang=js"
export * from "./AgConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./AgConfirmDialog.vue?vue&type=style&index=0&id=0768aa1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0768aa1b",
  null
  
)

export default component.exports